import { useContext, useEffect, useState } from "react"
import { useHistory } from "react-router"
import { authContext } from "../../context/AuthContext"
import * as Yup from 'yup';
import { withTranslation } from "react-i18next";
import LoadingList from "../../loader/LoadingList";
import { Field, Formik } from "formik";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import Get from "../../api/Get";
import { ACCOUNT_ACTIVE_ALL, ROLE_LIST, UPDATE_ROLE } from "../../api/Routes";
import Select from "react-select";
import Put from "../../api/Put";

function FormRole({t, id}){
    const [loading, setLoading] = useState(true)
    const {auth} = useContext(authContext)
    const [textLoad, setTextoLoad] = useState("Cargando...")
    const history = useHistory()
    const [accountOpt, setAccountOpt] = useState([])
    const [accountDefault, setAccountDefault] = useState([])

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }  

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        active: true,
        accounts : Yup.array().min(1,t('Camporequerido')),
    })

    useEffect(()=>{
        setLoading(true)
        let mounted = true;
        Get({url: ROLE_LIST, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                let obj = response.data.data.response.filter(e=>e.id===parseInt(id))
                let entity = {
                    id: id,
                    name: obj[0].name,
                    accounts: obj[0].accounts,
                    active: true
                }
                setAccountDefault(entity.accounts.map(e=>({label:e.name, value: e.id})))
                setInitialValues(entity)
                setLoading(false)
            }
            
        })
        .catch(error=>{
            setLoading(false)
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })

        //cuentas
        Get({url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                setAccountOpt(response.data.data.response.map(e=>({label: e.name, value: e.id})))
            }
            
        })
        .catch(error=>{
            console.log(error)
        })

        return () => mounted = false
    }, [])

    

    const shemaValidate = Yup.object().shape({
        name: Yup.string().required(t('Camporequerido')),
        account : Yup.array().min(1,t('Camporequerido')),
    });

    return (
        <>
        {
            loading ? <LoadingList texto={textLoad} /> :
            <Formik initialValues={initialValues}
                validationSchema={shemaValidate}
                onSubmit={(values, { setSubmitting, setFieldValue,setFieldError }) => { 
                    let data = Object.assign({}, values)
                    if(accountDefault.length === 0) {
                        data.accounts = null
                    }else{
                        data.accounts = accountDefault.map(e=>({id: e.value,name: e.label}))
                    }

                    Put({url: `${UPDATE_ROLE}/${id}`, data: data, header: true, access_token: auth.data.access_token})
                    .then(response=>{
                        setSubmitting(false)
                        history.push('/admin/roles')
                    })
                    .catch(error=>{
                        console.log(error)
                        setSubmitting(false)
                        setShowModalServer(true)
                        if(error.response){
                            setErrorServer(error.response)
                        }
                    })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setFieldError
            }) => (
                <Form onSubmit={handleSubmit}  className='mt-3'>
                    {isSubmitting && <LoadingList texto="Procesando solicitud"/>}
                    <input type="hidden" name="id" value={values.id} />
                    <Card className="shadow-1-2 formSection">
                        <Card.Body>
                            <Row>
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.name && 'error'}`}
                                            name="name"
                                        />
                                        { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                    </Form.Group>
                                </Col>
                            </Row>    
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Cuenta</Form.Label>
                                        <Select
                                            options={accountOpt} 
                                            value={accountDefault}
                                            onChange={setAccountDefault}
                                            isMulti
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>                    
                        </Card.Body>
                    </Card>
                    
                    <Row className="mt-4">
                        <Col className="text-right">
                            <Link to="/admin/roles" className="cancelar-buttom btn btn-outline-danger font-weight-bold text-white">Cancelar</Link>{' '}
                            <Button variant="outline-success" className="ok-buttom font-weight-bold" type="submit">Aceptar</Button>
                        </Col>
                    </Row>

                    <ComponentModalErrorSever
                        show={showModalServer}
                        handleClose={handleCloseModalServer}
                        error={errorServer}
                    />
                </Form>
            )}
        </Formik>
        }        
        </>
    )
}

export default withTranslation()(FormRole)